export const DATE_FORMAT_LONG = 'date-time-range/date-format-long';
export const DATE_FORMAT_SHORT = 'date-time-range/date-format-short';
export const DATE_FORMAT_DEFAULT = 'date-time-range/date-format-default';

export const DATE_FORMATS = [
    DATE_FORMAT_LONG,
    DATE_FORMAT_SHORT,
    DATE_FORMAT_DEFAULT
];